import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const RegisterPage = ({ onRegisterSuccess }) => {
  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_ENTRYPOINT;
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.userName,
          email: formData.email,
          password: formData.password,
          status: true,
        }),
      });

      if (response.ok) {
        setSuccess("Registration successful! Redirecting to login...");
        setFormData({ userName: "", email: "", password: "" });
        setTimeout(() => {
          navigate("/login");
        }, 1500);
        if (onRegisterSuccess) onRegisterSuccess();
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Registration failed. Please try again.");
      }
    } catch (err) {
      setError("Unable to connect to server. Please check your connection.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="min-vh-100 d-flex align-items-center"
      style={{
        background:"#1A365D"
          // "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="card border-0 shadow-lg overflow-hidden">
              <div className="row g-0">
                {/* Left Side - Visual */}
                <div
                  className="col-md-6 d-none d-md-flex align-items-center justify-content-center p-5 position-relative overflow-hidden"
                  style={{
                    backgroundImage:
                      "url('https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  {/* Gradient overlay with blur effect */}
                  <div
                    className="position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      background:"linear-gradient(135deg, rgba(164, 194, 237, 0.8) 0%, rgba(87, 126, 181, 0.55) 100%)",
                        // "linear-gradient(135deg, rgba(76, 0, 130, 0.8) 0%, rgba(102, 51, 153, 0.85) 100%)",
                      backdropFilter: "blur(1px)",
                    }}
                  ></div>

                  <div className="text-center text-white position-relative z-1 w-100">
                    <h2 className="fw-bold mb-3 display-4">Welcome</h2>
                    <p className="opacity-90 fs-5 mb-4 px-5">KGC'97 DAY 2026</p>
                  </div>
                </div>

                {/* Right Side - Form */}
                <div className="col-md-6">
                  <div className="p-5">
                    <div className="text-center mb-4">
                      <h3 className="fw-bold text-primary">Create Account</h3>
                      <p className="text-muted">Sign up to get started</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                      <div className="mb-4">
                        <div className="form-floating">
                          <input
                            type="text"
                            className={`form-control ${
                              error && !formData.userName ? "is-invalid" : ""
                            }`}
                            id="userName"
                            name="userName"
                            placeholder=" "
                            value={formData.userName}
                            onChange={handleChange}
                            required
                          />
                          <label htmlFor="userName">
                            <i className="bi bi-person me-2"></i>
                            Username
                          </label>
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="form-floating position-relative">
                          <input
                            type="password"
                            className={`form-control ${
                              error && !formData.password ? "is-invalid" : ""
                            }`}
                            id="password"
                            name="password"
                            placeholder=" "
                            value={formData.password}
                            onChange={handleChange}
                            required
                          />
                          <label htmlFor="password">
                            <i className="bi bi-lock me-2"></i>
                            Password
                          </label>
                          <button
                            type="button"
                            className="btn btn-link position-absolute end-0 top-0 mt-3 me-2"
                            onClick={() => {
                              const passwordField =
                                document.getElementById("password");
                              passwordField.type =
                                passwordField.type === "password"
                                  ? "text"
                                  : "password";
                            }}
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                        </div>
                        {/* <small className="text-muted">
                          Must be at least 8 characters with numbers and letters
                        </small> */}
                      </div>

                      {/* Error/Success Messages */}
                      {error && (
                        <div
                          className="alert alert-danger d-flex align-items-center"
                          role="alert"
                        >
                          <i className="bi bi-exclamation-triangle-fill me-2"></i>
                          <div>{error}</div>
                        </div>
                      )}

                      {success && (
                        <div
                          className="alert alert-success d-flex align-items-center"
                          role="alert"
                        >
                          <i className="bi bi-check-circle-fill me-2"></i>
                          <div>{success}</div>
                        </div>
                      )}

                      {/* Submit Button */}
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg w-100 mb-3"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Creating Account...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-person-plus me-2"></i>
                            Create Account
                          </>
                        )}
                      </button>

                      {/* Divider */}
                      <div className="text-center my-4">
                        <div className="d-flex align-items-center">
                          <hr className="flex-grow-1" />
                          <span className="px-3 text-muted small">OR</span>
                          <hr className="flex-grow-1" />
                        </div>
                      </div>

                      {/* Login Link */}
                      <div className="text-center">
                        <p className="text-muted">
                          Already have an account?{" "}
                          <button
                            type="button"
                            className="btn btn-link text-decoration-none p-0"
                            onClick={() => navigate("/login")}
                            disabled={isLoading}
                          >
                            <strong>Sign In</strong>
                          </button>
                        </p>
                      </div>

                      {/* Terms */}
                      <div className="text-center mt-4">
                        <small className="text-muted">
                          By signing up, you agree to our{" "}
                          <a href="/terms" className="text-decoration-none">
                            Terms
                          </a>{" "}
                          and{" "}
                          <a href="/privacy" className="text-decoration-none">
                            Privacy Policy
                          </a>
                        </small>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
